import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track, identify, peopleUnset } from "../lib/mixpanel";
import { trackPageView } from "../lib/funnels";

const isMeaningful = (value) =>
  value != null && value !== "" && value !== "undefined" && value !== "null";

export function useHomeAnalytics(customerInfo, userType) {
  const location = useLocation();

  useEffect(() => {
    const context = {
      userType,
      isLoggedIn: !!customerInfo?._id,
      referrer: document.referrer || "direct",
    };
    track("Home: Page Viewed", { ...context, path: location.pathname });
    trackPageView("home", context);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!customerInfo?._id) return;

    const raw = {
      $email: customerInfo.email,
      $name: customerInfo.name,
      $phone: customerInfo.mobile,
      mobile: customerInfo.mobile,
      userType,
    };

    const profile = {};
    const toUnset = [];
    for (const [key, value] of Object.entries(raw)) {
      if (isMeaningful(value)) profile[key] = value;
      else if (key.startsWith("$") || key === "mobile") toUnset.push(key);
    }

    identify(customerInfo._id, profile);
    if (toUnset.length) peopleUnset(toUnset);
  }, [customerInfo, userType]);
}
